var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrap",attrs:{"id":"mainWrap"}},[_c('KHeader',{attrs:{"scrollTop":_vm.scrollTop}}),_c('div',{staticClass:"content"},[_c('RouterView')],1),_c('KFooter'),_c('KBacktop',{attrs:{"show":_vm.showBackTop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }